// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/use-referral/:code\",\"regex\":\"^/use-referral/([^/]+)$\",\"paramNames\":[\"code\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/account/feedback\"},{\"path\":\"/account/help\"},{\"path\":\"/account/payments\"},{\"path\":\"/account/payments/choose-plan\"},{\"path\":\"/account/payments/purchase\"},{\"path\":\"/account/payments/subscribe\"},{\"path\":\"/account/payments/success\"},{\"path\":\"/account/preferences\"},{\"path\":\"/account/referrals\"},{\"path\":\"/account/settings\"},{\"path\":\"/account/suspend\"},{\"path\":\"/get-started\"},{\"path\":\"/home\"},{\"path\":\"/trial-activate\"},{\"path\":\"/view-job/error\"},{\"path\":\"/admin\"},{\"path\":\"/admin/job-alerts\"},{\"path\":\"/admin/notification-logs\"},{\"path\":\"/admin/notify-user\"},{\"path\":\"/admin/subscribers\"},{\"path\":\"/auth/auth-code-error\"},{\"path\":\"/auth/login\"},{\"path\":\"/auth/register\"},{\"path\":\"/churn-feedback\"},{\"path\":\"/download\"},{\"path\":\"/legal\"},{\"path\":\"/legal/contact-us\"},{\"path\":\"/legal/cookie-policy\"},{\"path\":\"/legal/data-deletion\"},{\"path\":\"/legal/privacy-policy\"},{\"path\":\"/legal/return-policy\"},{\"path\":\"/legal/shipping-policy\"},{\"path\":\"/legal/terms-of-service\"},{\"path\":\"/offline\"},{\"path\":\"/unsubscribe\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";
import { env } from "@/app/env";

Sentry.init({
  dsn: env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: ["production", "staging"].includes(env.NEXT_PUBLIC_SENTRY_ENVIRONMENT),
  environment: env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  // Add optional integrations for additional features
  integrations: [Sentry.replayIntegration()],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

// PostHog Analytics initialization
// https://posthog.com/docs/libraries/next-js
import posthog from "posthog-js";
import { isKnownTestUserDevice, registerAccessContext } from "@/lib/analytics/auth-tracking";

if (typeof window !== "undefined") {
  posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: "/ph",
    ui_host: "https://eu.posthog.com",
    person_profiles: "identified_only",
    // App Router navigations are client-side; "history_change" counts them as pageviews too.
    capture_pageview: "history_change",
    capture_pageleave: true,
    capture_exceptions: true,
    autocapture: false,
    // Test users' sessions are noise; syncProfileAnalytics also stops replay once the profile loads.
    disable_session_recording: isKnownTestUserDevice(),
    debug: false,
    opt_out_capturing_by_default: env.NEXT_PUBLIC_SENTRY_ENVIRONMENT === "development",
  });
  registerAccessContext();
}
